<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="详情信息"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="20" :offset="2">
          <el-descriptions :column="3" border>
            <el-descriptions-item label="ICCID">{{detail.iccid}}</el-descriptions-item>
            <el-descriptions-item label="卡号">{{detail.card_number}}</el-descriptions-item>
            <el-descriptions-item label="设备唯一码">{{detail.device_unique}}</el-descriptions-item>
            <el-descriptions-item label="inst">{{detail.inst}}</el-descriptions-item>
            <el-descriptions-item label="imei">{{detail.imei}}</el-descriptions-item>
            <el-descriptions-item label="pin1">{{detail.pin1}}</el-descriptions-item>
            <el-descriptions-item label="pin2">{{detail.pin2}}</el-descriptions-item>
            <el-descriptions-item label="puk1">{{detail.puk1}}</el-descriptions-item>
            <el-descriptions-item label="puk2">{{detail.puk2}}</el-descriptions-item>
            <el-descriptions-item label="备注">{{detail.whither}}</el-descriptions-item>
            <el-descriptions-item label="激活状态">{{detail.active_desc}}</el-descriptions-item>
            <el-descriptions-item label="激活时间">{{detail.active_at}}</el-descriptions-item>
            <el-descriptions-item label="到期时间">{{detail.expire_at}}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: '',
      },
      detail: {},
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {},
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.detail = {}
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminSimDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.detail = {}
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>